import * as CostCategory from '@/services/rest-api/lib/cost-management/category'

export default {
  computed: {
    costFields() {
      return [
        {
          name: 'activity_id',
          key: 'activity.name',
          label: this.$t('costManagement.fields.costCategoryName'),
          placeholder: `${this.$t('global.form.select')} ${this.$t('costManagement.fields.costCategoryName')}`,
          isEditable: true,
          isSortable: false,
          validation: 'required',
          type: 'select-resourceful',
          trackBy: 'id',
          displayedBy: 'name',
          optionsGetter: CostCategory.get,
          optionLabelFn: ({ item }) => item.name,
          getInitialObject: (obj) => obj,
          thStyle: 'width: 150px'
        },
        {
          name: 'activity_chart_of_account',
          key: 'activity_chart_of_account',
          label: this.$t('costManagement.fields.costAccountNumber'),
          type: 'text',
          placeholder: `${this.$t('global.form.enter')} ${this.$t('costManagement.fields.costAccountNumber')}`,
          isEditable: false,
          isSortable: false,
          thStyle: 'width: 150px',
          tdClass: 'mc-amount-col-head'
        },
        {
          name: 'amount',
          key: 'amount',
          label: this.$t('costManagement.fields.cost'),
          _type: 'number',
          placeholder: `${this.$t('global.form.enter')} ${this.$t('costManagement.fields.cost')}`,
          validation: 'bail|required|number|min:1,value|max:100000000000,value|integer',
          'validation-messages': {
            min: this.$t('global.validation.minPositiveOnly')
          },
          value: 1,
          isEditable: true,
          isSortable: false,
          thStyle: 'width: 150px',
          tdClass: 'mc-amount-col-head'
        },
        {
          name: 'file',
          key: 'attachment',
          label: this.$t('costManagement.fields.attachedProof'),
          type: 'file',
          placeholder: 'Lampirkan Bukti',
          isEditable: true,
          isSortable: false,
          thStyle: 'width: 200px',
        }
      ]
    }
  }
}
